/**
 * Canonical iframe detection for RAM embed mode (e.g. Cockpit RamEmbed).
 * Use {@link useIsEmbedded} in React components; call this helper in non-hook code.
 */
export function isEmbeddedInIframe(): boolean {
    return typeof window !== 'undefined' && window.self !== window.top;
}

/** Alias for cockpit navigation call sites. */
export const isRamEmbeddedInCockpit = isEmbeddedInIframe;
